import React, {Component} from 'react';
import {connect} from 'react-redux';
import {redirectToContinueAfterValidationCode} from '../../ducks/Customer';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

import './styles.scss';

class IntermediateReturn extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.IntermediateReturn.title,
    );
  }

  render() {
    return (
      <div className="div-intermediate-return">
        <div className="header">
          <p>Olá, {this.props.nome}! :)</p>
        </div>

        <div className="content">
          <div className="info">
            <p>Que bom ter você de volta ;)</p>
            <br></br>
            <div className="spotlight">
              <p>Vamos continuar de onde você parou?</p>
            </div>
          </div>
        </div>

        <div className="button-container-flex">
          <div className="button-container">
            <button
              className="button"
              onClick={() => {
                this.props.redirectToContinueAfterValidationCode(
                  this.props.situacao,
                );
              }}
            >
              CONTINUAR
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({customer}) => {
  const {situacao, dadosPessoais} = customer;
  return {
    situacao,
    nome: dadosPessoais.nome,
  };
};

export default connect(mapStateToProps, {
  redirectToContinueAfterValidationCode,
})(IntermediateReturn);
